<template>
  <SelectMultipleInput
    v-model="model"
    :items="items"
    item-text="roleName"
    item-value="roleCd"
    :label="labelComputed"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectMultipleInput from '@/components/atoms/base/select/SelectMultipleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'RoleInput',

  mixins: [APIUtils, Message],

  components: {
    SelectMultipleInput,
  },

  props: {
    value: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label ? this.label : this.$t('ELE0046')
      },
    },
  },
  async mounted() {
    this.loading = true
    try {
      const params = {}
      if (this.validOnly) {
        params.validOnly = true
      }
      this.items = await API.get('/master/roles', params)
    } catch (error) {
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0005') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
